module.exports = __webpack_public_path__ + "static/media/switch_mandatory.c05e3509.png";